import { ReduxAction } from '../../types/common'
import { GET_TERRITORIES } from '../actionTypes'

interface TerritoryState {
  territories: null | string
}

export interface Territory {
  businessTerritoryId: number
  name: string
  description: string
  state: string
  logo: string
}

const INITIAL_STATE = {
  territories: null,
  errors: '',
}

export const territories = (state: TerritoryState = INITIAL_STATE, action: ReduxAction) => {
  switch (action.type) {
    case GET_TERRITORIES:
      return {
        ...state,
        territories: action.payload.territories,
      }
    default:
      return state
  }
}
